import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['blockquote', 'code-block'],
    ['link'],
    ['clean']
  ],
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet',
  'blockquote', 'code-block',
  'link'
];

const RichTextEditor = ({ value, onChange, placeholder = 'Write your content here...' }) => {
  return (
    <div className="rich-text-editor">
      <style>{`
        .rich-text-editor .ql-toolbar {
          background: rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 6px 6px 0 0;
        }
        .rich-text-editor .ql-toolbar .ql-stroke {
          stroke: #9CA3AF;
        }
        .rich-text-editor .ql-toolbar .ql-fill {
          fill: #9CA3AF;
        }
        .rich-text-editor .ql-toolbar .ql-picker {
          color: #9CA3AF;
        }
        .rich-text-editor .ql-toolbar button:hover .ql-stroke,
        .rich-text-editor .ql-toolbar button.ql-active .ql-stroke {
          stroke: #C5A059;
        }
        .rich-text-editor .ql-toolbar button:hover .ql-fill,
        .rich-text-editor .ql-toolbar button.ql-active .ql-fill {
          fill: #C5A059;
        }
        .rich-text-editor .ql-container {
          background: rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-top: none;
          border-radius: 0 0 6px 6px;
          min-height: 200px;
          font-family: 'Inter', sans-serif;
        }
        .rich-text-editor .ql-editor {
          color: #fff;
          font-size: 14px;
          line-height: 1.6;
        }
        .rich-text-editor .ql-editor.ql-blank::before {
          color: rgba(255, 255, 255, 0.4);
          font-style: normal;
        }
        .rich-text-editor .ql-editor h1, 
        .rich-text-editor .ql-editor h2, 
        .rich-text-editor .ql-editor h3 {
          color: #fff;
        }
        .rich-text-editor .ql-editor blockquote {
          border-left-color: #C5A059;
          color: #9CA3AF;
        }
        .rich-text-editor .ql-editor pre.ql-syntax {
          background: rgba(0, 0, 0, 0.5);
          color: #C5A059;
          border-radius: 4px;
        }
        .rich-text-editor .ql-editor a {
          color: #007AFF;
        }
        .rich-text-editor .ql-snow .ql-picker-options {
          background: #111111;
          border-color: rgba(255, 255, 255, 0.1);
        }
        .rich-text-editor .ql-snow .ql-picker-label:hover,
        .rich-text-editor .ql-snow .ql-picker-item:hover {
          color: #C5A059;
        }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
